import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CommentsLibrary } from '@exploreorg/explore-comments';
import { modal } from 'react-redux-modal';
import queryString from 'query-string';
import { setCurrentSection } from '../../actions/globalConfig';
import './styles.scss';
import PageContent from '../../components/StaticPage/PageContent';
import NotFoundView from '../NotFound';
import { disqusCheckAndRefreshSSO } from '../../actions/auth';
import { LoginModalView } from '../../components/Modals';
import { commentsConfig } from '../../utils';
import { Loader } from '../../components';

const propTypes = {
  statusText: PropTypes.string,
  sectionName: PropTypes.string,
  userName: PropTypes.string,
  profileImage: PropTypes.string,
  remoteAuthS3: PropTypes.string,
  pageCommentsBoardId: PropTypes.string,
};

const defaultProps = {
  sectionName: '',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png',
  shortName: 'exploreorg',
  remoteAuthS3: '',
  pageCommentsBoardId: null,
};

const conf = commentsConfig();

class StaticView extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(window.location.search);
    const { commentId } = query;
    this.state = {
      commentId,
      queryResults: {},
      query: _.get(this.props, 'params.content', null),
      loading: false,
    };
    this.clearCommentId = this.clearCommentId.bind(this);
    this.openLogin = this.openLogin.bind(this);
    this.refreshComments = this.refreshComments.bind(this);
  }

  componentDidMount() {
    const { pageTitle } = this.props;
    this.props.dispatch(disqusCheckAndRefreshSSO());
    this.ssoInterval = setInterval(() => {
      this.props.dispatch(disqusCheckAndRefreshSSO());
    }, 1000 * 60);
    if (!contentTitle) return;
    let contentTitle = this.replaceAll(pageTitle, '-', ' ');
    this.props.dispatch(setCurrentSection(contentTitle));
    document.body.addEventListener('click', function (evt) {
      if (evt.target.className === 'scroll-link') {
        evt.preventDefault();
        const target = evt.target.href.replace('#', '');
        const element = document.getElementById(target);
        element.scrollIntoView();
      }
    }, false);
  }

  componentWillReceiveProps(nextProps) {
    this.props.dispatch(disqusCheckAndRefreshSSO());
  }

  componentDidUpdate() {
    const { pageTitle } = this.props;
    if (!contentTitle) return;
    let contentTitle = this.replaceAll(pageTitle, '-', ' ');
    this.props.dispatch(setCurrentSection(contentTitle));
  }

  escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

  openLogin(e){
    e.preventDefault();
    modal.add(LoginModalView, {title:'', size: 'medium', hideTitleBar:true, id:'login'});
  }

  clearCommentId() {
    const params = new URLSearchParams(window.location.search);
    const commentIdQueryParam = params.get('commentId');

    if (commentIdQueryParam) {
      params.delete('commentId');
      const stringifiedParams = params.toString();

      const newUrl = `${window.location.pathname}${
        stringifiedParams ? `?${stringifiedParams}` : ''
      }`;
      window.history.pushState({}, document.title, newUrl);
      this.setState({ commentId: null });
    }
  }
  refreshComments() {
    this.setState({ loading: true });
    setTimeout(() => this.setState({ loading: false }), 500);
  }

  render() {
    const {
      pageTitle,
      pageCommentsBoardId,
      disqusThreadVersion,
      pageContent,
      staticPageLoading,
      pageData,
      commentToken,
    } = this.props;

    const { commentId, loading } = this.state;

    const pageCommentsEnabled = pageCommentsBoardId && pageCommentsBoardId.length > 0;

    if (!pageContent && !staticPageLoading) {
      return (<NotFoundView />);
    }
    const { show_title: showTitle, published, css, pageUrl } = pageData;
    const slug = window.location.pathname;
    const identifier = disqusThreadVersion > 0 ? `${slug}-${disqusThreadVersion}` : slug;

    const commentModuleParameters = {
      theme: 'light',
      token: commentToken,
      boardId: pageCommentsBoardId,
      commentId,
    };

    return (
      <div className="container-fluid content static-page bg-fff-65">
        {css && (
          <style>
            {css}
          </style>
        )}
        {!published && (
          <div className="row">
            <div className="col">
            <div className="alert alert-info">
              This page is in <strong>preview mode</strong>. To make it live, toggle the <strong>publish</strong> switch in the CMS
            </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12 pr-35 pl-35">
            {showTitle && (<h1>{pageTitle}</h1>)}
            <div className="static-page-top-block">&nbsp;</div>
            {pageContent && <PageContent content={pageContent} />}
          </div>
        </div>
        {pageCommentsEnabled && (
          <div className="row">
            <div className="col-sm-12 pr-35 pl-35">
              <div className="d-flex flex-wrap justify-content-end mb-1 mx-3">
                <button className="btn btn-secondary btn-sm d-inline-block" onClick={this.refreshComments}>
                  <span className="icon font-weight-bold" style={{ fontSize: '1.35em' }}>⟳</span> Refresh comments
                </button>
              </div>
              {loading && (<div className="position-relative" style={{ height: '200px'}}> <Loader fill dark style={{ height: 200 }} /> </div>)}
              {!loading && (<CommentsLibrary
                config={conf}
                {...commentModuleParameters}
                removeCommentIdFromUrlParams={this.clearCommentId}
                onLoginClick={this.openLogin}
                pageUrl={pageUrl}
              />)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath,
    pageContent: state.globalConfig.pageContent,
    pageTitle: state.globalConfig.pageTitle,
    pageCommentsBoardId: state.globalConfig.pageCommentsBoardId,
    pageCommentsEnabled: state.globalConfig.pageCommentsEnabled,
    disqusThreadVersion: state.globalConfig.disqusThreadVersion,
    remoteAuthS3: state.auth.disqus_sso,
    isAuthenticated: state.auth.isAuthenticated,
    staticPageLoading: state.globalConfig.staticPageLoading,
    pageData: state.globalConfig.pageData,
    commentToken: state.auth.commentToken,
  };
};

StaticView.propTypes = propTypes;
StaticView.defaultProps = defaultProps;

export default connect(mapStateToProps)(StaticView);
